import type { FC } from 'react';
import { SliderWithUnitInputComponent } from '~/_shared/components/slider/sliderWithUnitInput/sliderWithUnitInput.component';

const FILL_OPACITY_MIN = 0;
const FILL_OPACITY_MAX = 100;
const FILL_OPACITY_UNIT = '%';

type FillOpacitySliderProps = Readonly<{
  className?: string;
  label?: string;
  value: number;
  onChange: (value: number) => void;
}>;

export const FillOpacitySliderComponent: FC<FillOpacitySliderProps> = ({
  className,
  label,
  value,
  onChange,
}) => (
  <SliderWithUnitInputComponent
    className={className}
    label={label}
    max={FILL_OPACITY_MAX}
    min={FILL_OPACITY_MIN}
    onChange={onChange}
    unit={FILL_OPACITY_UNIT}
    value={value}
  />
);
